var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-container',[_c('user-details',{attrs:{"data":_vm.userDetails,"token":_vm.token}}),_c('mobile-clients',{attrs:{"data":_vm.userClients}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }